var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "searchIconMain", style: _vm.searchWrapperStyle },
    [
      _c("div", { staticClass: "searchInput", style: _vm.searchInputStyle }, [
        _vm._v(_vm._s(_vm.content == "" ? _vm.prompt : _vm.content))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "searchButton", style: _vm.searchButtonStyle }, [
        _vm._v("搜索")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }